<nav class="header-navbar navbar-expand-md navbar navbar-with-menu fixed-top navbar-semi-dark navbar-shadow" style="background: #407590 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
opacity: 1;">

  <div class="navbar-wrapper">
    <div class="navbar-header" style="background: #407590 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    opacity: 1;">
      <ul class="nav navbar-nav flex-row">
        <li class="nav-item mobile-menu d-md-none mr-auto"><a class="nav-link nav-menu-main menu-toggle hidden-xs"
            href="#"><i class="ft-menu white font-large-1"></i></a></li>
        <li class="nav-item"><a class="navbar-brand">
            <img class="brand-logo" alt="logo geia" src="../../../assets/app-assets/images/logo/logo_branco_esfera.png">
            <h3 class="brand-text">Géia</h3>
          </a></li>

        <li class="nav-item d-md-none"><a class="nav-link open-navbar-container" data-toggle="collapse"
            data-target="#navbar-mobile"><i class="fa fa-ellipsis-v"></i></a></li>
      </ul>
    </div>
    <div class="navbar-container content">
      <div class="collapse navbar-collapse" id="navbar-mobile">
        <ul class="nav navbar-nav mr-auto float-left">
          <li class="nav-item d-none d-md-block"><a class="nav-link nav-menu-main menu-toggle hidden-xs" href="#"><i
                class="ft-menu white"> </i></a></li>

        </ul>
        <ul class="nav navbar-nav float-right">


          <li class="dropdown dropdown-user nav-item"><a class="dropdown-toggle white nav-link dropdown-user-link"
              href="#" data-toggle="dropdown">
              <span class="avatar white avatar-online"><img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQz1K1evWjMTfR3IMBxQxXSGV2pTaO2rAP7EzIMB4u0YwxfFL4pJ269eff6sNvuxtjI7c4&usqp=CAU"
                  alt="avatar"><i></i></span>
              <span class="user-name white">Olá, {{nomeUsuario}}


              </span></a>
            <div class="dropdown-menu dropdown-menu-right">
              <a [routerLink]="'/usuario/perfil'" class="dropdown-item"><i class="ft-user"></i>Perfil</a>



              <div class="dropdown-divider"></div><a class="dropdown-item" (click)="onLogout()"
                href="javascript:void(0)"><i class="ft-power"></i> Logout</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>

</nav>